import React, { useState, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

const Tabs = ({ tabs }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const storageKey = `lastTab_${location.pathname}`;

  const tabParam = searchParams.get("tab");
  const savedTab = sessionStorage.getItem(storageKey);

  const defaultIndex = tabs.findIndex((t) =>
    t.label.toLowerCase() === (tabParam || savedTab)?.toLowerCase()
  );

  const [activeIndex, setActiveIndex] = useState(defaultIndex >= 0 ? defaultIndex : 0);

  useEffect(() => {
    const currentTabLabel = tabs[activeIndex]?.label?.toLowerCase();
    if (currentTabLabel) {
      // Get current params and only update 'tab'
      const newParams = new URLSearchParams(searchParams);
      if (newParams.get("tab") !== currentTabLabel) {
        newParams.set("tab", currentTabLabel);
        setSearchParams(newParams);
      }
      // Persistence fallback for breadcrumbs
      sessionStorage.setItem(storageKey, currentTabLabel);
    }
  }, [activeIndex, setSearchParams, tabs, searchParams, storageKey]);

  return (
    <div className="w-full">

      <div className="flex border-b border-gray-200 dark:border-gray-700">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`px-4 py-2 -mb-px font-medium text-sm rounded-t-lg transition-colors ${activeIndex === index
                ? "border-b-2 border-brand-500 text-brand-600 dark:text-brand-400"
                : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>


      <div className="mt-4 p-4 rounded-lg bg-white dark:bg-gray-800 shadow-sm">
        {tabs[activeIndex].content}
      </div>
    </div>
  );
};

export default Tabs;




// import React, { useState } from "react";

// const Tabs = ({ tabs, options, active, setActive }) => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const getActiveTabContent = () => {
// 		const c = options.find((o) => o.id === active);
// 		return c ? c.content : "";
// 	};



//   return (
//     <div className="w-full">
//       <div className="flex border-b border-gray-200 dark:border-gray-700">
//         {tabs.map((tab, index) => (
//           <button
//             key={index}
//             onClick={() => setActiveIndex(index)}
//             className={`px-4 py-2 -mb-px font-medium text-sm rounded-t-lg transition-colors ${
//               activeIndex === index
//                 ? "border-b-2 border-brand-500 text-brand-600 dark:text-brand-400"
//                 : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
//             }`}
//           >
//             {tab.label}
//           </button>
//         ))}
//       </div>

//       <div className="mt-4 p-4 rounded-lg bg-white dark:bg-gray-800 shadow-sm">
//         {tabs[activeIndex].content}
//       </div>
//     </div>
//   );

// };

// export default Tabs;
